import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import images from 'components/CameraModelSelector/Filter/formFactorImages'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'

const initialFormFactors = ['box', 'bullet', 'covert', 'cube', 'dome', 'ptz', 'turret', 'multi-imager']

class Filter extends React.Component {
  state = { showSearchBar: true }

  showSearch = _ => {
    this.setState({ showSearchBar: true }, _ => this.refs.searchInput.focus())
  }

  hideSearch = _ => {
    this.setState({ showSearchBar: false })
    // TBD: clear search?
  }

  render() {
    const { showSearch, hideSearch, props: { selectedManufacturer, filterCameras, search, formFactors, classes }, state: { showSearchBar } } = this

    if (showSearchBar) {
      return (
        <div className={classes.filterContainer}>
          <div className={classes.searchWrapper}>
            <input
              type='search'
              placeholder={selectedManufacturer ? `Search ${selectedManufacturer}...` : 'Search...'}
              onChange={({ target: { value } }) => filterCameras(null, value)}
              onKeyPress={e => e.key === 'Enter' && e.target.blur()}
              value={search}
              ref='searchInput'
            />
          </div>
          <div className={classes.searchButton} onClick={hideSearch}>
            <FontAwesomeIcon icon='sliders-h' />
          </div>
        </div>
      )
    }

    return (
      <div className={classes.filterContainer}>
        <div className={classes.formFactors}>
          {
            initialFormFactors.map((name) =>
              <div
                className={classes.formFactor + (formFactors.includes(name) ? ' selected' : '')}
                onClick={_ => filterCameras(formFactors.includes(name) ? formFactors.filter(f => f !== name) : [ ...formFactors, name ], null, null)}
                key={name}
              >
                <img src={name === 'multi-imager' ? images["multi_imager"] : images[name]} className={classes.image} />
                { name === 'multi-imager' ? 'Multi' : capitalizeFirstLetter(name) }
              </div>
            )
          }
        </div>
        <div className={classes.searchButton} onClick={showSearch}>
          <FontAwesomeIcon icon='arrow-left' />
        </div>
      </div>
    )
  }
}

export default (injectSheet(style)(Filter))



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/Filter/index.js